import type { ISelectedExperimentType } from '../../types/studio/studio';



export const PLAN_STATUS_OPTIONS = [
  { label: "DASHBOARD.IMPLEMENTED", value: "implemented" },
  { label: "DASHBOARD.APPROVED", value: "approved" },
  { label: "DASHBOARD.IN_PROGRESS", value: "in_progress" },
  { label: "DASHBOARD.TEST", value: "test" }
];

export const experimentTypes = [
  {
    label: "STUDIO.ASSORTMENT",
    value: "assortment",
  },
  {
    label: "STUDIO.PLANOGRAM",
    value: "planogram",
  },
  {
    label: "STUDIO.SPACE_PLANOGRAM",
    value: "space_assortment",
  },
  {
    label: "STUDIO.DATA_EXPLORATION",
    value: "data exploration",
  },
  {
    label: "STUDIO.CLUSTERING",
    value: "clustering",
  },
  {
    label: "STUDIO.BULK_PLANO",
    value: "bulk_plano"
  }
];

export const selectedExperimentType: ISelectedExperimentType = {
  planogram: ["planogram", "space_assortment", "bulk_plano"],
  assortment: ["assortment"]
};

export const groupByOptions = [
  // { label: "GROUP_BY.FOLDER", value: "folder" },
  // { label: "GROUP_BY.TAG", value: "tag" },
  // { label: "GROUP_BY.TYPE", value: "type" },
  { label: "GROUP_BY.COUNTRY", value: "country" },
  { label: "GROUP_BY.REGION", value: "region" },
  { label: "GROUP_BY.KEY_ACCOUNT", value: "ka" },
  { label: "GROUP_BY.CREATED_AT", value: "created" },
  { label: "GROUP_BY.CREATED_BY", value: "created_by" }
  // { label: "GROUP_BY.STATUS", value: "status" }
];

export const experimentTypesMap: any = {
  assortment: "Assortment",
  planogram: "Planogram",
  space_assortment: "Space Planogram",
  bulk_plano: "Bulk Plano",
  "data exploration": "Data Exploration",
  clustering: "Clustering"
};

export const statusMap: any = {
  test: "Test",
  in_progress: "In Progress",
  completed: "Completed",
  approved: "Approved",
  implemented: "Implemented",
  cloning: "Completed"
};

